import { useLayoutEffect } from 'react';
import { useLocation } from 'react-router';

import { appServiceUrl } from '@libs/serviceUrls';

import { isKakaoInAppBrowser } from '@app/libs/browserUserAgent';
import { redirectToKakaoOAuthPage } from '@app/libs/oauth/redirectToKakaoOAuthPage';

const autoLoginDisabledSessionStorageKey = 'modusign-kakaoAutoLoginDisabled';

// 프리뷰에서 자동로그인 시도시 redirect url 불일치로 오류가 생겨서 자동로그인이 불가능합니다.
const isEnabled = appServiceUrl.includes(window.location.origin) && isKakaoInAppBrowser();

export default function useKakaoAutoLogin(options?: { disabled?: boolean }) {
  const location = useLocation();

  useLayoutEffect(() => {
    if (
      isEnabled &&
      !window.sessionStorage.getItem(autoLoginDisabledSessionStorageKey) &&
      !options?.disabled !== false
    ) {
      redirectToKakaoOAuthPage({
        mode: 'autoLogin',
        redirectTo: `${location.pathname}${location.search}`,
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
}

const allowedPath = ['/participant', '/authentication/signin'];

export function tryKakaoAutoLogin() {
  if (
    isEnabled &&
    !window.sessionStorage.getItem(autoLoginDisabledSessionStorageKey) &&
    allowedPath.includes(window.location.pathname)
  ) {
    // 페이지를 로드하면서 리소스를 불러오는 중 리다이렉트되어서 청크오류가 발생, 오류 페이지가 렌더링됩니다.
    // UX 개선을 위해 리다이렉트 직전에 body를 비워서 오류페이지가 보이지 않게합니다.
    // 참고: https://modusign.slack.com/archives/C022S16PU15/p1666665244889039
    window.document.body.innerHTML = '';
    redirectToKakaoOAuthPage({
      mode: 'autoLogin',
      redirectTo: `${window.location.pathname}${window.location.search}`,
    });
  }
}

export function disableKakaoAutoLogin() {
  window.sessionStorage.setItem(autoLoginDisabledSessionStorageKey, 'true');
}
